import { ReactNode } from 'react';

import { Text, useColorModeValue } from '@ecoinvent/ui';

type TooltipBodyProps = {
  children: ReactNode;
};

const TooltipBody = ({ children }: TooltipBodyProps) => (
  <Text fontSize="xs" color={useColorModeValue('gray.400', undefined)}>
    {children}
  </Text>
);

export default TooltipBody;
